import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, Checkbox, RadioGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepTwo(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

        useEffect(() => {
            if (props.datas.activity && Object.keys(props.datas.activity).length >= 1) {
                buttons[1].disabled = false;
            } else {
                buttons[1].disabled = true;
            }
            setButtons([...buttons]);
        }, [props.datas]);

    function handleChange(e){
        let datas = Object.assign({}, props.datas);
        if(!datas.activity){
            datas.activity = [];
        }
        let filtered = datas.activity.filter( data => data != e.target.value);
        if(e.target.checked){
            filtered.push(e.target.value);
        }
        datas.activity = filtered;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Dans quel domaine d’activité êtes-vous ? (Plusieurs réponses possibles)
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue="public"
                        name="radio-buttons-group">
                        <FormControlLabel value="Restaurations" control={<Checkbox name='activity' onChange={(e) => handleChange(e)}/>} label="Restaurations"/>
                        <FormControlLabel value="Prêt à porter" control={<Checkbox name='activity' onChange={(e) => handleChange(e)}/>} label="Prêt à porter" />
                        <FormControlLabel value="Décoration" control={<Checkbox name='activity' onChange={(e) => handleChange(e)}/>} label="Décoration" />
                        <FormControlLabel value="Tourisme (guides, boutiques de souvenirs…)" control={<Checkbox name='activity' onChange={(e) => handleChange(e)}/>} label="Tourisme (guides, boutiques de souvenirs…)" />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons}/>
        </>
    )
}